var e, n;
function t() {
  return n || (n = 1, e = function(r) {
    return r.filter(function(u, i) {
      return r.indexOf(u) === i;
    });
  }), e;
}
export {
  t as __require
};
